import { ViewModel, View } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class ToolTypeSelectorViewModel extends SelectorBaseViewModel<ToolType> {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }

    protected async loadData(): Promise<ToolType[]> {
        let result = await ServerConnection.callServer('/Complex/ToolTypeServices/ListAllToolTypes', {})
        return result.ToolTypes.map(x => {
            let t = new ToolType(this);
            t.id = x.Id;
            t.title = `${x.Name} (${x.Code})`;
            return t;
        });
    }
}

export class ToolType extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
}